export default __webpack_public_path__ + "static/media/vectorya secret.59ca503e.svg";